module.exports = __webpack_public_path__ + "image/p6-pic1-wap.1727328807492.jpg";